<template>
  <div id="app">
    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
</template>
<script>
export default {
  name: "App",
  async created() {
    let data = await this.$http.get("/api/commonSetting");
    this.$store.commit("setCommonSetting", data);
  }
};
</script>
<style lang="scss">
@import "@/assets/css/common.scss";

.v-view .ivu-spin-fix {
  z-index: 9999;
}
</style>
